import { FeatureFlag } from "utils/feature-flag";
import * as _ from 'lodash/fp'
import { pipe } from "ts-pipe-compose";

function stepIsActive(
  settings,
  stepId,
  colorSettingId,
  currentEngineTransmission,
  currentVariant,
  order
) {
  if (stepId === 4) {
    if (order.paymentType === 'cash' && currentVariant?.has_cash_accessories) {
      return true
    }

    if (order.paymentType === 'leasing' && currentVariant?.has_leasing_accessories) {
      return true
    }
  }

  return Object.values(settings).filter((setting) => {
    const options = Array.isArray(setting.options) ? { ...setting.options } : setting.options
    const optionValues = Object.values(options).filter(option => {
      if (option.type === 'accessory-product' && !FeatureFlag.accessoryShop()) {
        return false
      }

      const hidden = option.hide_on === order.paymentType || option.hide_on === 'all'
      if (hidden) {
        return false
      }

      if (option.engines_required?.length > 0) {
        if (!option.engines_required.includes(currentEngineTransmission.engine_id)) {
          return false
        }
      }

      if (option.transmission_required?.length > 0) {
        if (!option.transmission_required.includes(currentEngineTransmission.transmission_id)) {
          return false
        }
      }

      let colorId = order.configuration?.color?.id ?? '0'
      const selectedColorId = colorSettingId !== null ? colorId.replace(colorSettingId + '_', '') : colorId // colorId
      if (option.colors_required?.length > 0) {
        if (!option.colors_required.includes(selectedColorId)) {
          return false
        }
      }

      return true
    })

    return optionValues.length > 0
  }).length > 0
}

function stepExists(steps, step_id) {
  steps = { ...steps }
  const keys = Object.keys(steps)
  const steps_count = keys.length

  for (let i = 0; i < steps_count; i++) {
    if (steps[keys[i]].step_id == step_id) {
      return true
    }
  }

  return false
}

function getStepByStepId(steps, step_id) {
  steps = { ...steps }
  const keys = Object.keys(steps)
  const steps_count = keys.length

  for (let i = 0; i < steps_count; i++) {
    if (steps[keys[i]].step_id == step_id) {
      return steps[keys[i]]
    }
  }

  return null
}

function validateStep(step, order, isDealerConfigurator, currentVariant) {
  const configuration = order.configuration

  if (step.step_id === 1) {
    if (typeof configuration.variants !== 'object' || configuration.variants === null) return false // It is not set : (
  }

  if (step.step_id === 5) {
    return !isDealerConfigurator ? validateStep5(order, currentVariant) : validateDealerStep5(order)
  }

  const settings = _.values(step.settings ?? {})
  const settings_length = settings.length
  for (let i = 0; i < settings_length; i++) {
    const setting = settings[i]
    if (setting.required == 1) {
      // This setting has to be set
      if (step.step_id === 3) {
        if (!Array.isArray(configuration.extra_equipments[setting.id]) || configuration.extra_equipments[setting.id].length === 0) return false // It is not set : (
      } else {
        if (typeof configuration[setting.id] !== 'object' || configuration[setting.id] === null) return false // It is not set : (
      }
    }
  }

  return true
}

function validateSteps(steps, order, isDealerConfigurator, currentVariant) {
  const valid_steps = []
  steps = Object.values(steps)
  const steps_length = steps.length

  for (let i = 0; i < steps_length; i++) {
    const valid = validateStep(steps[i], order, isDealerConfigurator, currentVariant)
    if (valid === true) {
      valid_steps.push(steps[i].step_id)
    } else {
      return valid_steps // If this one is not valid then user is not allowed to see the next step
    }
  }

  return valid_steps
}

function validateStep5(order, currentVariant) {
  const show_restpayment = Boolean(Number(currentVariant?.steps?.[5]?.show_restpayment ?? '0'))
  const service_agreement = Boolean(Number(currentVariant?.steps?.[5]?.show_service_deal ?? '0'))
  const show_insurance = Boolean(Number(currentVariant?.steps?.[5]?.show_insurance ?? '0'))
  const show_trade = Boolean(Number(currentVariant?.steps?.[5]?.show_tradein ?? '0'))
  const show_guarantee_price = Boolean(Number(currentVariant?.steps?.[5]?.show_guarantee_price ?? '0'))
  const show_pickup_location = Boolean(Number(currentVariant?.steps?.[5]?.show_dealer ?? '0'))
  const show_payment_terms = Boolean(Number(currentVariant?.steps?.[5]?.show_payment_terms ?? '0'))

  const required_fields = [
    'first_name',
    'last_name',
    'street_address',
    'city_address',
    'postnumber_address',
    'telephone',
    'email',
    ...(show_pickup_location ? ['pickup_location'] : []),
    ...(show_insurance ? ['insurance'] : []),
  ]

  if (show_trade) {
    if (order.paymentType === 'cash' || (order.paymentType === 'leasing' && show_guarantee_price)) {
      required_fields.push('trade')
    }
  }

  const fields_length = required_fields.length
  for (let i = 0; i < fields_length; i++) {
    const val = order[required_fields[i]]
    if (typeof val !== 'string' || val.length < 1) return false
  }
  if (order.paymentType === 'leasing') {
    // LEASING RULES!!

    // As of 2024-04-08, the cpr field isn't used anymore, so this is commented out
    // if (typeof order.cpr !== 'string' || order.cpr.match(/(\d{6})(-| )?(\d{4})/) < 1) return false
  } else {
    // CASH RULES
    if (show_restpayment) {
      if (typeof order.rest_payment !== 'string' || order.rest_payment.length < 1) return false
    }
    if (service_agreement) {
      if (typeof order.service_agreement !== 'string' || order.service_agreement.length < 1) return false
    }
  }
  if (show_trade) {
    if (order.trade === 'yes') {
      if (typeof order.trade_plate !== 'string' || order.trade_plate.length < 1) return false
      if (typeof order.trade_km !== 'string' || order.trade_km.length < 1) return false
    }
  }

  if (show_payment_terms && order.payment_terms_accepted !== true) {
    return false
  }

  return true
}

function validateDealerStep5(order) {
  const dealerOrderType = order.dealer_order_type ?? ''
  const dealerVehicleType = order.dealer_vehicle_type ?? ''

  if (dealerOrderType === null || dealerVehicleType === null) {
    return false
  }

  if (dealerOrderType === 'customer_car') {
    const required_fields = [
      'first_name',
      'last_name',
      'street_address',
      'city_address',
      'postnumber_address',
      'telephone',
      'email'
    ]
    const fields_length = required_fields.length

    for (let i = 0; i < fields_length; i++) {
      const val = order[required_fields[i]]

      if (typeof val !== 'string' || val.length < 1) {
        return false
      }
    }
  }

  return true
}

// export function getOptions(variant) {
//   return pipe(variant, getSettings, _.flatMap(_.pipe(_.get('options'), _.values)))
// }

function getSettings(variant) {
  return pipe(variant, _.get('steps'), _.values, _.flatMap(_.pipe(_.get('settings'), _.values)))
}

function filterOptionsByVariant(_configuration, variant) {
  return _configuration
}

function filterOptionByPaymentType(configuration, payment_type) {
  return clean(
    Object.fromEntries(
      Object.entries(configuration).map(([key, option]) => {
        if (option === null) return [key, option]
        if (option.hide_on === payment_type) return [key, null]
        return [key, option]
      })
    )
  )
}

function clean(obj) {
  for (const propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName]
    }
  }
  return obj
}

// function cleanEngineTransmission() {
//   const engineTransmission = Env.get('currentEngineTransmission')
//
//   return {
//     id: engineTransmission.id,
//     engine_id: engineTransmission.engine_id,
//     transmission_id: engineTransmission.transmission_id
//   }
// }

export {
  stepIsActive,
  stepExists,
  getStepByStepId,
  validateStep,
  validateSteps,
  getSettings,
  filterOptionsByVariant,
  filterOptionByPaymentType
}
